(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add-modal-styles"] && !Shopify.designMode) return;
  try {
    (function() {
  function initQuickAddZoom() {
    var modalContent = document.getElementById('quick-add-modal-content');
    if (!modalContent) return;
    /* Create zoom dialog once (uses showModal for top-layer stacking above quick-add dialog) */
    var overlay = document.getElementById('quick-add-zoom-overlay');
    if (!overlay) {
      overlay = document.createElement('dialog');
      overlay.id = 'quick-add-zoom-overlay';
      overlay.innerHTML = '<button class="quick-add-zoom-close" aria-label="Close zoom">\u00D7</button><img class="quick-add-zoom-img" src="" alt="">';
      document.body.appendChild(overlay);
      var closeZoom = function() {
        overlay.close();
      };
      overlay.addEventListener('click', function(e) {
        if (e.target === overlay || e.target.classList.contains('quick-add-zoom-close')) {
          closeZoom();
        }
      });
      overlay.addEventListener('cancel', function(e) {
        e.preventDefault();
        closeZoom();
      });
    }
    /* Event delegation — works with dynamically loaded content */
    modalContent.addEventListener('click', function(e) {
      var zoomButton = e.target.closest('.product-media-container__zoom-button, .product__media-icon');
      var productImage = e.target.closest('img.product-media__image, .product-media img');
      if (!zoomButton && !productImage) return;
      e.preventDefault();
      e.stopPropagation();
      var img;
      if (zoomButton) {
        var container = zoomButton.closest('.product-media-container') || zoomButton.closest('.product-media');
        img = container ? container.querySelector('img') : null;
      } else {
        img = productImage;
      }
      if (!img) return;
      var highRes = img.getAttribute('data-max-resolution') || img.getAttribute('data_max_resolution') || img.currentSrc || img.src;
      var zoomImg = overlay.querySelector('.quick-add-zoom-img');
      zoomImg.src = highRes;
      zoomImg.alt = img.alt || 'Product image';
      overlay.showModal();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickAddZoom);
  } else {
    initQuickAddZoom();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
